export default "__VITE_ASSET__C7L7sGd0__"